import { parseQueryStatNumber } from "./queryBuilder";
import { getNbaAllTimeGreatsStat } from "../constants/nbaAllTimeGreats";

export const getNbaLeaderboardStatFormat = (stat) =>
  stat === "ppg" ? "decimal2" : "count";

export const getNbaLeaderboardStatValue = (player, stat) => {
  const config = getNbaAllTimeGreatsStat(stat);
  return parseQueryStatNumber(player[config.statField]) ?? 0;
};

export const buildNbaLeaderboardRows = (
  players = [],
  stat,
  { page = 0, pageSize = 25 } = {}
) =>
  players.map((player, index) => ({
    id: player.playerId || player._id || `row-${index}`,
    rank: page * pageSize + index + 1,
    playerId: player.playerId,
    playerName: player.name || player.bioData?.displayName || "Unknown",
    statValue: getNbaLeaderboardStatValue(player, stat),
    position: player.position || player.bioData?.position || "—",
    games: player.games ?? "—",
  }));
